import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

interface Props {
  data?: any;
}

// eslint-disable-next-line
const data = [
  { name: 'Withdrawal', value: 400 },
  { name: 'Deposit', value: 300 },
];
const COLORS = ['#00b7cb', '#0070f0'];

export default function DoughnutChart(props: Props) {
  return (
    <PieChart width={250} height={400}>
      <Pie
        data={props.data}
        cx={120}
        cy={200}
        innerRadius={60}
        outerRadius={100}
        fill="#8884d8"
        dataKey="value"
      >
        {props.data.map((entry: any, index: any) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  );
}
